<template>
    <div class="moduleAssignment-content">
        <div class="module-header">
            <h1 class="wk_headline" v-text="localize('moduleAssignment')"></h1>
        </div>
        <p class="module-body-header" v-text="localize('moduleAssignmentBody')"></p>
        <!-- Load Panel -->
        <DxLoadPanel :position="position"
                     :visible="loadingVisible"
                     :show-indicator="showIndicator"
                     :show-pane="showPane"
                     :shading="shading"
                     shading-color="rgba(255,255,255,.8)" />
        <!-- End Load Panel -->
        <!--Popup start-->
        <template>
            <div id="assign-copmany-popup">
                <DxPopup :visible="popupVisible"
                         :show-title="true"
                         :height="540"
                         :width="'50%'"
                         :show-close-button="false"
                         :title="localize('moduleAssigningCompaniesHeader')">
                    <DxToolbarItem widget="dxButton"
                                   toolbar="top"
                                   location="after"
                                   :options="closeButtonOptions" />
                    <!-- companies list -->
                    <div class="company-lists-area">
                        <!-- Start list 1 -->
                        <div class="company-list-area-col">
                            <template>
                                <div>
                                    <div class="list-container"
                                         v-if="currentModule && currentModule.moduledefid">
                                        <h5 class="mb-3 column-header">{{localize('moduleAssignExistingCompanies')}}</h5>
                                        <DxList :data-source="unAssigned"
                                                :height="400"
                                                :search-enabled="true"
                                                :search-mode="searchMode"
                                                :indicate-loading="true"
                                                selection-mode="single"
                                                :selected-items="[]"
                                                key-expr="id"
                                                search-expr="name"
                                                @item-click="getCompanyUnAssignments">
                                            <template #item="{ data }">
                                                <div>
                                                    <div>{{ data.name }}</div>
                                                </div>
                                            </template>
                                        </DxList>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- End list 3 -->
                        <!-- Start List Swithcer -->
                        <div class="company-list-area-col">
                            <div class="switcher">
                                <div class="swithcer-unassign">
                                    <DxButton type="default"
                                              :disabled="!unAssignedCurrentCompany"
                                              icon="chevronright"
                                              :use-submit-behavior="false"
                                              @click="companyAssignments(unAssignedCurrentCompany)">
                                    </DxButton>
                                </div>
                                <div class="swithcer-assign">
                                    <DxButton type="default"
                                              :disabled="!assignedCurrentCompany"
                                              icon="chevronleft"
                                              :use-submit-behavior="false"
                                              @click="companyAssignments(assignedCurrentCompany)">
                                    </DxButton>
                                </div>
                            </div>
                        </div>
                        <!-- End list Switcher -->
                        <!-- List 3 -->
                        <div class="company-list-area-col">
                            <template>
                                <div>
                                    <div class="list-container"
                                         v-if="currentModule && currentModule.moduledefid">
                                        <h5 class="mb-3 column-header">{{localize('moduleAssignedCompanies')}}</h5>

                                        <DxList :data-source="assigned"
                                                :height="400"
                                                :search-enabled="true"
                                                :search-mode="searchMode"
                                                :indicate-loading="true"
                                                selection-mode="single"
                                                :selected-items="[]"
                                                key-expr="id"
                                                search-expr="name"
                                                @item-click="getCompanyAssignments">
                                            <template #item="{ data }">
                                                <div>
                                                    <div>{{ data.name }}</div>
                                                </div>
                                            </template>
                                        </DxList>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- End List 1 -->

                    </div>
                    <!-- End companies list -->
                </DxPopup>
            </div>
        </template>

        <!--Popup end-->
        <!--Grid start-->
        <div class="grid-top">
            <DxDataGrid :data-source="modulesDataSource"
                        :row-alternation-enabled="true"
                        :show-row-lines="true"
                        :show-borders="true"
                        :column-auto-width="true"
                        key-expr="generalmoddefid">
                <DxPaging :page-size="10" />
                <DxPager :visible="true"
                         :allowed-page-sizes="[10, 20, 50]"
                         :show-page-size-selector="true"
                         :show-navigation-buttons="true" />

                <DxColumn class="grid-content"
                          :caption="localize('moudleAssignName')"
                          cell-template="module-name" />
                <template #module-name="{ data }">
                    <span>{{ data.data.generalmoddef.friendlyname }}</span>
                </template>
                <DxColumn :caption="localize('moduleAssignAllCompanies')"
                          cell-template="all-companies-assignments" />
                <template #all-companies-assignments="{ data }">
                    <DxCheckBox :value="data.data.moduleAcessConfig.allowAllCompanies"
                                mode="multiple"
                                @value-changed="allCompaniesAssignments(data.data)" />
                </template>
                <DxColumn :caption="localize('moduleAssignToCompany')"
                          cell-template="assign-company-template" />
                <template #assign-company-template="{ data }">
                    <DxButton :disabled="data.data.moduleAcessConfig.allowAllCompanies"
                              type="default"
                              styling-mode="contained"
                              @click="getModuleCompany(data.data)"
                              :text="localize('moduleAssignToCompanyBtn')">
                    </DxButton>
                </template>
            </DxDataGrid>
        </div>
        <!--Grid end-->
    </div>
</template>
<script>
    //End Configration Area
    import Vue from "vue";
    import axios from "axios";
    import config from "../../config/config.js";
    import ResourceHelper from "@common/globalization/ResourceHelper";
    import { DxCheckBox } from "devextreme-vue/check-box";
    import { DxLoadPanel } from "devextreme-vue/load-panel";
    import {
        DxDataGrid,
        DxColumn,
        DxPager,
        DxPaging,
    } from "devextreme-vue/data-grid";
    import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
    import DxList from "devextreme-vue/list";
    import { DxButton } from "devextreme-vue/button";
    import { BootstrapVue } from "bootstrap-vue";
    import "bootstrap/dist/css/bootstrap.css";
    import "bootstrap-vue/dist/bootstrap-vue.css";
    import "vue-multiselect-listbox/dist/vue-multi-select-listbox.css";
    import * as AspNetData from "devextreme-aspnet-data-nojquery";
    Vue.use(BootstrapVue);

    export default {
        name: "ModuleAssignment",
        components: {
            DxDataGrid,
            DxPager,
            DxPaging,
            DxColumn,
            DxCheckBox,
            DxPopup,
            DxButton,
            DxToolbarItem,
            DxList,
            DxLoadPanel,
        },

        data() {
            return {
                unAssigned: [],
                assigned: [],
                currentModule: null,
                modulesDataSource: [],

                unAssignedCurrentCompany: null,
                assignedCurrentCompany: null,

                position: {},
                showIndicator: true,
                loadingVisible: false,
                shading: true,
                showPane: true,
                popupVisible: false,
                searchMode: "contains",
                assignToCompany: true,
                CheckBoxValue: null,

                assignModule: {
                    class: "assign-module",
                },
                closeButtonOptions: {
                    icon: "close",
                    onClick: () => {
                        this.popupVisible = false;
                        this.init();
                    },
                },
            };
        },
        //Localization
        methods: {
            //init
            init() {
                this.assigned = []
                this.unAssigned = [];
                this.assignedCurrentCompany = null;
                this.unAssignedCurrentCompany = null;
            },
            localize: (string) => {
                let status = ResourceHelper.getString(string);
                return status;
            },
            //Assign & Un Assign all companies
            allCompaniesAssignments(moduleData) {
                let moduleId = moduleData.moduledefid;
                let assignedStatus = !moduleData.moduleAcessConfig.allowAllCompanies;

                //Set the load panel
                this.position = { of: ".dx-datagrid-rowsview" };
                this.loadingVisible = true;
                axios({
                    method: "put",
                    url: `${config.nbCoreApiUrl}/${moduleId}/allow-all/${assignedStatus}`,
                    headers: {
                        "portal-id": getCookie("PortalId"),
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                        "Authorization": "Bearer " + getCookie("ApiToken")

                    },
                })
                    .then(() => {
                        this.getAllModules();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        this.loadingVisible = false;
                    });
            },
            //Get & set an Assign company
            getCompanyAssignments(e) {
                if (e.itemData) {
                    this.assignedCurrentCompany = {
                        companyId: e.itemData.id,
                        moduleDefinitionId: this.currentModule.moduledefid,
                        assignCompany: false,
                    };
                    this.assignedItemSelected = true;
                }
            },
            //Get & set an unAssign company
            getCompanyUnAssignments(e) {
                if (e.itemData) {
                    this.unAssignedCurrentCompany = {
                        companyId: e.itemData.id,
                        moduleDefinitionId: this.currentModule.moduledefid,
                        assignCompany: true,
                    };
                    this.unAssignedItemSelected = true;
                }
            },

            //POST to assign & un assign companies company
            companyAssignments(companyData) {
                if (companyData) {
                    let data = companyData;
                    axios({
                        method: "post",
                        url: `${config.nbCoreApiUrl}/api/module-management/module-company`,
                        headers: {
                            "portal-id": getCookie("PortalId"),
                            "Authorization": "Bearer " + getCookie("ApiToken"),
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                        },
                        data,
                    })
                        .then(() => {
                            this.init();
                            this.getListsDataSource();

                        })
                        .catch((err) => {
                            console.log(err)
                        })
                        .finally(() => { });
                }
            },
            //Get All modules to the main grid
            listModules() {
                return AspNetData.createStore({
                    key: "moduledefid",
                    loadUrl: `${config.nbCoreApiUrl}/api/module-management/list-modules?loadOptions=''`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            "portal-id": getCookie("PortalId"),
                            authorization: "Bearer " + getCookie("ApiToken"),
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                        };
                    },
                });
            },
            getAllModules() {
                this.modulesDataSource = this.listModules();
            },

            //Get current module
            getModuleCompany(moduleData) {
                //rest compaines
                this.currentModule = moduleData;
                //Get list data sources
                this.getListsDataSource();
                //Show popup
                this.popupVisible = true;
            },

            //Get list data sources
            getListsDataSource() {
                this.unAssigned = this.unAssignedDataSource();
                this.assigned = this.assignedDataSource();
            },
            //Get un assigned companies DataSource
            unAssignedDataSource() {
                return AspNetData.createStore({
                    key: "moduledefid",
                    loadUrl: `${config.nbCoreApiUrl}/api/module-management/${this.currentModule.moduledefid}/companies/false`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            "portal-id": getCookie("PortalId"),
                            authorization: "Bearer " + getCookie("ApiToken"),
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                        };
                    },
                });
            },

            //Get un assigned companies DataSource
            assignedDataSource() {
                return AspNetData.createStore({
                    key: "moduledefid",
                    loadUrl: `${config.nbCoreApiUrl}/api/module-management/${this.currentModule.moduledefid}/companies/true`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            "portal-id": getCookie("PortalId"),
                            authorization: "Bearer " + getCookie("ApiToken"),
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                        };
                    },
                });
            },
        },

        created: function () {
            this.getAllModules();
        },
    };
</script>

<style>
    .moduleAssignment-content {
        margin: 45px;
        border: none !important;
        display: flex !important;
        justify-content: center !important;
        flex-direction: column;
    }

    .grid-top {
        min-height: 400px !important;
        display: block;
    }

    .column-header {
        font-size: 14px;
        font-weight: bold;
    }

    .module-header {
        margin-bottom: .5rem;
        color: rgb(175, 1, 1);
    }

    .module-body-header {
        margin-bottom: 2rem;
        font-size: 16px;
    }

    .assign-button {
        background-color: rgb(175, 1, 1);
        padding: 8px !important;
        border: hidden;
        color: #fff;
    }

    .grid-top td {
        padding: 10px !important;
    }

    .grid-top td {
        color: rgb(102, 102, 102) !important;
    }

    .grid-loader {
        display: flex;
        justify-content: center;
    }

    .dx-header-row > td > .dx-datagrid-text-content {
        font-weight: 600 !important;
    }

    .list-body {
        width: 100% !important;
        padding: 40px;
        height: 450px;
        border-color: rgb(177, 177, 177) !important;
    }

    .msl-searchable-list__items {
        border: 1px solid #9e9e9e !important;
    }

    .msl-searchable-list__item {
        border-bottom: 1px solid #9e9e9e !important;
    }

    .custom-input-class {
        height: 30px !important;
        padding: 10px;
        border: 1px solid #9e9e9e !important;
    }

    .list-body a {
        color: #414751 !important;
        font-size: 17px !important;
    }

        .list-body a:hover {
            color: rgb(175, 1, 1) !important;
        }

    svg.multi-select__action-icon {
        display: none !important;
    }

    .msl-searchable-list__item:hover {
        background-color: #585858 !important;
        color: #ffffff;
    }

    .msl-searchable-list__item {
        padding: 12px;
    }

    .company-lists-area {
        display: flex;
        flex-direction: row;
    }

        .company-lists-area .dx-scrollable-wrapper {
            border: 1px solid rgb(221, 221, 221);
            border-radius: 4px;
        }

        .company-lists-area .company-list-area-col:first-child {
            flex-grow: 1;
            min-width: calc(55% - 100px);
        }

        .company-lists-area .company-list-area-col:last-child {
            flex-grow: 1;
            min-width: calc(55% - 100px);
        }

        .company-lists-area .company-list-area-col:nth-child(2) {
            min-width: 100px;
            display: flex;
            align-self: center;
            justify-content: center;
            flex-direction: column;
        }

        .company-lists-area .company-list-area-col .switcher {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

            .company-lists-area .company-list-area-col .switcher .swithcer-assign {
                margin: 1rem 0;
            }

    .dx-template-wrapper.dx-item-content.dx-list-item-content div {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }
</style>
